import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BannerMessage } from '../../models/banner-message.model';

@Injectable({
  providedIn: 'root'
})
export class BannerMessageService {

  constructor(
    protected readonly http: HttpClient,
  ) { }

  /**
   * Get banner messages from asset file
   */
  getBannerData(): Observable<Array<BannerMessage>> {
    return this.http.get<Array<BannerMessage>>(`assets/data/bannerMessages.json`);
  }
}
